<div class="card mb-3">

    <div class="card-header">
        <span translate>organization.name.info</span>
    </div>

    <div class="card-body">
        <mat-form-field class = "full-width">
            <mat-label translate>organization.field.name</mat-label>
            <input [(ngModel)]="_organization.name" matInput required>
        </mat-form-field>

        <mat-form-field class = "full-width">
            <mat-label translate>organization.field.vatRegistration</mat-label>
            <input [(ngModel)]="_organization.vatRegistration" matInput>
        </mat-form-field>

        <!-- <mat-form-field class = "full-width">
            <mat-label translate>organization.field.municipality</mat-label>
            <input [(ngModel)]="_organization.municipality" matInput required>
        </mat-form-field> -->
        
        <mat-form-field class = "full-width">
            <mat-label translate>organization.field.zipcode</mat-label>
            <input [(ngModel)]="_organization.zipCode" matInput required>
        </mat-form-field>
        
        <mat-form-field class = "full-width">
            <mat-label translate>organization.field.address</mat-label>
            <input [(ngModel)]="_organization.address" matInput required>
        </mat-form-field>

        <place-autocomplete #autocompleteManager  
                            [preselect]     =   "{id: _organization.placeId}"
                            (placeChange)   = "placeChanged($event)"></place-autocomplete>
        
        <!-- 
        <mat-form-field class = "full-width">
            <mat-label translate>organization.field.addressNumber</mat-label>
            <input [(ngModel)]="_organization.addressNumber" matInput required>
        </mat-form-field> -->
        
        <mat-form-field class = "full-width">
            <mat-label translate>organization.field.latitude</mat-label>
            <input [(ngModel)]="_organization.latitude" matInput required>
        </mat-form-field>

        <mat-form-field class = "full-width">
            <mat-label translate>organization.field.longitude</mat-label>
            <input [(ngModel)]="_organization.longitude" matInput required>
        </mat-form-field>

        <mat-form-field class = "full-width">
            <mat-label translate>organization.field.email</mat-label>
            <input [(ngModel)]="_organization.email" matInput required>
        </mat-form-field>
        
        <mat-form-field class = "full-width">
            <mat-label translate>organization.field.phone</mat-label>
            <input [(ngModel)]="_organization.phone" matInput required>
        </mat-form-field>
    </div>
</div>